import { toast } from "react-toastify";

import api from "../api";
import { formatCustomerDetails } from "../formatResponses/customer";

export class CustomerDetails {
  async find(customerId) {
    try {
      const { data } = await api.get(
        `/customer/${encodeURIComponent(customerId)}/details`
      );

      return {
        details: formatCustomerDetails(data),
        error: null,
      };
    } catch (error) {
      const message =
        error.response?.data?.friendly_message ||
        error.message ||
        "Não foi possível carregar os detalhes do cliente.";

      toast.error(message, { theme: "colored" });

      return {
        details: null,
        error: message,
      };
    }
  }
}

let MCustomerDetails = null;

export function CustomerDetailsModel() {
  if (!MCustomerDetails) MCustomerDetails = new CustomerDetails();
  return MCustomerDetails;
}

